import React from 'react'
import { useLocation, useNavigate, Link as RouterLink } from 'react-router-dom'
import { Box, Container, Link, Paper, Stack, Typography, Alert } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useAuth } from '../context/AuthContext'

const Register: React.FC = () => {
  const { t } = useTranslation()
  const location = useLocation()
  const navigate = useNavigate()
  const { authenticated, ready } = useAuth()

  const searchParams = React.useMemo(() => new URLSearchParams(location.search), [location.search])
  const redirectParam = searchParams.get('redirect') || '/new'
  const redirect = React.useMemo(() => {
    if (typeof window === 'undefined') {
      return redirectParam.startsWith('/') ? redirectParam : `/${redirectParam}`
    }
    try {
      const url = new URL(redirectParam, window.location.origin)
      if (url.origin !== window.location.origin) {
        return '/new'
      }
      const relative = `${url.pathname}${url.search}${url.hash}`
      return relative || '/new'
    } catch {
      return redirectParam.startsWith('/') ? redirectParam : `/${redirectParam}`
    }
  }, [redirectParam])

  React.useEffect(() => {
    if (ready && authenticated) {
      navigate(redirect, { replace: true })
    }
  }, [authenticated, ready, navigate, redirect])

  return (
    <Container maxWidth="sm" sx={{ py: 6 }}>
      <Paper elevation={3} sx={{ p: { xs: 3, md: 4 } }}>
        <Stack spacing={3}>
          <Box>
            <Typography variant="h4" component="h1" gutterBottom>
              {t('auth.registerTitle')}
            </Typography>
            <Typography variant="body1" color="text.secondary">
              {t('auth.registerDescription')}
            </Typography>
          </Box>

          <Alert severity="info">
            {t('auth.registerInfo', 'Schreib uns eine kurze Nachricht, und wir schalten deinen Account frei.')}
          </Alert>

          <Stack direction="row" spacing={1} alignItems="center" justifyContent="center">
            <Typography variant="body2" color="text.secondary">
              {t('auth.haveAccount')}
            </Typography>
            <Link component={RouterLink} to={`/login?redirect=${encodeURIComponent(redirect)}`} variant="body2">
              {t('auth.backToLogin')}
            </Link>
          </Stack>
        </Stack>
      </Paper>
    </Container>
  )
}

export default Register
